import api from "lib/api";

export const getPosition = async (params = {}) => {
  return await api.post("/v1/position/getPosition", params);
};

export const createPosition = async (params = {}) => {
  return await api.post("/v1/position/createPosition", params);
};

export const updatePosition = async (params = {}) => {
  return await api.post("/v1/position/updatePosition", params);
};
export const managePosition = async (params = {}) => {
  return await api.post("/v1/stp/manageStatusLeaveTypeCompany", params);
};

export const dropdownhPosition = async (params = {}) => {
  return await api.post("/v1/dropdown/getPosition", params);
};

export const deletePosition = async (params = {}) => {
  return await api.post("/v1/position/deletePosition", params);
};
